import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
var propTypes = {
  /**
   * Content that will be passed to the list.
   */
  children: PropTypes.node,

  /**
   * If provided, used as string that labels the element for accessibility.
   */
  ariaLabel: PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};
var defaultProps = {};
var StyledUl = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledUl",
  componentId: "VDS__sc-1fa46xw-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n"])));

var UnorderedList = function UnorderedList(props) {
  var id = props.id,
      children = props.children,
      className = props.className;
  return /*#__PURE__*/React.createElement(StyledUl, {
    id: id,
    className: className
  }, children);
};

UnorderedList.propTypes = propTypes;
UnorderedList.defaultProps = defaultProps;
UnorderedList.displayName = 'UnorderedList';
export default UnorderedList;